import React from 'react';
import { 
  Scissors, Sparkles, UserCircle, Heart, Hand, Palette, Sun,
  Stethoscope, CircleDot, Activity, Brain, Salad, Eye, PawPrint, Pill, Microscope, Glasses,
  Dumbbell, Waves, Trophy, PersonStanding, Flower2, Music, Swords, CircleDot as Tennis, Flag,
  UtensilsCrossed, Pizza, Coffee, Cake, IceCream, Fish, Sandwich, Beer, Wine, ChefHat, Truck,
  Building2, BedDouble, Home, Umbrella, Tent, Backpack, Palmtree, Plane,
  Car, CarFront, CarTaxiFront, Bike, PlaneTakeoff, ParkingCircle, Bus, Sailboat, Train, Ship,
  Wrench, Zap, CircleDot as Tire, Droplets,
  GraduationCap, BookOpen, Languages, Calculator, Laptop, TestTube, Brush,
  Camera, Video, Megaphone, PenTool, Globe, Printer,
  ShoppingBag, Shirt, Watch, Gem, Gift, Flower,
  Dog, Bone, Scissors as PetScissors,
  HardHat, Hammer, Paintbrush, Lightbulb, AirVent, Sofa, Leaf,
  Scale, FileText, Briefcase, Building,
  Ticket, Calendar, PartyPopper, Users
} from 'lucide-react';

// Mapping from category slug to Lucide icon component
export const CATEGORY_ICONS = {
  // Bellezza e Cura Personale
  'parrucchieri': Scissors,
  'estetisti': Sparkles,
  'barbieri': UserCircle,
  'centri-benessere': Heart,
  'massaggiatori': Hand,
  'tatuatori': Palette,
  'solarium': Sun,
  
  // Salute
  'medici': Stethoscope,
  'dentisti': CircleDot,
  'fisioterapisti': Activity,
  'psicologi': Brain,
  'nutrizionisti': Salad,
  'oculisti': Eye,
  'veterinari': PawPrint,
  'farmacie': Pill,
  'laboratori': Microscope,
  'ottici': Glasses,
  
  // Sport e Fitness
  'palestre': Dumbbell,
  'piscine': Waves,
  'campi-sportivi': Trophy,
  'personal-trainer': PersonStanding,
  'yoga-pilates': Flower2,
  'scuole-danza': Music,
  'arti-marziali': Swords,
  'tennis-padel': Tennis,
  'golf': Flag,
  
  // Ristorazione
  'ristoranti': UtensilsCrossed,
  'pizzerie': Pizza,
  'bar-caffe': Coffee,
  'pasticcerie': Cake,
  'gelaterie': IceCream,
  'sushi': Fish,
  'fast-food': Sandwich,
  'pub-birrerie': Beer,
  'enoteche': Wine,
  'catering': ChefHat,
  'food-truck': Truck,
  
  // Alloggi e Viaggi
  'hotel': Building2,
  'bed-breakfast': BedDouble,
  'agriturismi': Home,
  'case-vacanza': Umbrella,
  'campeggi': Tent,
  'ostelli': Backpack,
  'resort': Palmtree,
  'agenzie-viaggi': Plane,
  
  // Trasporti
  'taxi': CarTaxiFront,
  'ncc': CarFront,
  'noleggio-auto': Car,
  'noleggio-moto': Bike,
  'noleggio-bici': Bike,
  'transfer-aeroporto': PlaneTakeoff,
  'parcheggi': ParkingCircle,
  'autobus-turistici': Bus,
  'barche-yacht': Sailboat,
  'treni': Train,
  'voli-aerei': Plane,
  'autobus-linea': Bus,
  'pullman': Bus,
  'traghetti': Ship,
  
  // Servizi Auto
  'meccanici': Wrench,
  'carrozzerie': Car,
  'elettrauto': Zap,
  'gommisti': Tire,
  'autolavaggi': Droplets,
  
  // Formazione
  'scuole': GraduationCap,
  'corsi-formazione': BookOpen,
  'scuole-lingue': Languages,
  'ripetizioni': Calculator,
  'corsi-informatica': Laptop,
  'laboratori-didattici': TestTube,
  'scuole-arte': Brush,
  
  // Servizi Creativi
  'fotografi': Camera,
  'videomaker': Video,
  'marketing': Megaphone,
  'grafici': PenTool,
  'web-agency': Globe,
  'tipografie': Printer,
  
  // Shopping
  'negozi': ShoppingBag,
  'abbigliamento': Shirt,
  'gioiellerie': Watch,
  'profumerie': Gem,
  'regali': Gift,
  'fioristi': Flower,
  
  // Animali
  'toelettatura': Dog,
  'pensioni-animali': Bone,
  'addestramento': PawPrint,
  
  // Casa e Manutenzione
  'idraulici': Wrench,
  'elettricisti': Lightbulb,
  'muratori': HardHat,
  'imbianchini': Paintbrush,
  'climatizzazione': AirVent,
  'arredamento': Sofa,
  'giardinieri': Leaf,
  
  // Servizi Professionali
  'avvocati': Scale,
  'commercialisti': FileText,
  'consulenti': Briefcase,
  'agenzie-immobiliari': Building,
  
  // Eventi
  'organizzatori-eventi': Calendar,
  'wedding-planner': PartyPopper,
  'dj-animatori': Music,
  'catering-eventi': ChefHat,
  'location-eventi': Building2,
  'noleggio-attrezzature': Truck,
  
  // Default
  'default': ShoppingBag
};

// Get icon color class based on category color
export const getCategoryColorClass = (color) => {
  const colorMap = {
    'purple': 'text-purple-500',
    'pink': 'text-pink-500',
    'blue': 'text-blue-500',
    'teal': 'text-teal-500',
    'indigo': 'text-indigo-500',
    'slate': 'text-slate-500',
    'amber': 'text-amber-500',
    'emerald': 'text-emerald-500',
    'cyan': 'text-cyan-500',
    'violet': 'text-violet-500',
    'green': 'text-green-500',
    'sky': 'text-sky-500',
    'lime': 'text-lime-500',
    'red': 'text-red-500',
    'orange': 'text-orange-500',
    'yellow': 'text-yellow-500',
    'rose': 'text-rose-500',
    'gray': 'text-gray-500',
  };
  return colorMap[color] || 'text-emerald-500';
};

// Get icon background class based on category color
export const getCategoryBgClass = (color) => {
  const colorMap = {
    'purple': 'bg-purple-50',
    'pink': 'bg-pink-50',
    'blue': 'bg-blue-50',
    'teal': 'bg-teal-50',
    'indigo': 'bg-indigo-50',
    'slate': 'bg-slate-50',
    'amber': 'bg-amber-50',
    'emerald': 'bg-emerald-50',
    'cyan': 'bg-cyan-50',
    'violet': 'bg-violet-50',
    'green': 'bg-green-50',
    'sky': 'bg-sky-50',
    'lime': 'bg-lime-50',
    'red': 'bg-red-50',
    'orange': 'bg-orange-50',
    'yellow': 'bg-yellow-50',
    'rose': 'bg-rose-50',
    'gray': 'bg-gray-50',
  };
  return colorMap[color] || 'bg-emerald-50';
};

// Category Icon Component
export const CategoryIcon = ({ slug, color, size = 'md', className = '' }) => {
  const IconComponent = CATEGORY_ICONS[slug] || CATEGORY_ICONS['default'];
  const colorClass = getCategoryColorClass(color);
  
  const sizeClasses = {
    'sm': 'w-4 h-4',
    'md': 'w-5 h-5',
    'lg': 'w-6 h-6',
    'xl': 'w-8 h-8'
  };
  
  return <IconComponent className={`${sizeClasses[size]} ${colorClass} ${className}`} />;
};

export default CategoryIcon;
